import Reveal from "./Reveal";
import CountUp from "./CountUp";
import CtaButton from "./CtaButton";

const INCLUDED = [
  "app EscapeFlow (beta, acesso antecipado)",
  "grupo exclusivo no whatsapp",
  "1 a 2 aulas ao vivo",
  "oferta fundadora da escape club",
];

const Pricing = () => (
  <section id="preco" className="scroll-mt-8 bg-neutral-50 px-6 py-20 sm:py-28">
    <Reveal className="mx-auto max-w-md">
      <div className="e21-glass rounded-3xl px-7 py-10 text-center shadow-[0_20px_60px_rgba(0,0,0,0.08)] sm:px-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-black/35">
          próxima turma
        </span>

        <p className="e21-serif mt-6 text-6xl tracking-tight sm:text-7xl">
          <CountUp
            end={27.9}
            className="tabular-nums"
            formatter={(n) => `R$${n.toFixed(2).replace(".", ",")}`}
          />
        </p>
        <p className="mt-2 text-lg font-bold tracking-[-0.02em] sm:text-xl">
          um real por dia.
        </p>

        <ul className="mt-8 space-y-3 border-t border-black/10 pt-8 text-left">
          {INCLUDED.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm sm:text-base">
              <svg
                viewBox="0 0 16 16"
                fill="none"
                className="mt-1 h-4 w-4 flex-none"
              >
                <path
                  d="M3 8.5 6.5 12 13 4.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {item}
            </li>
          ))}
        </ul>

        <p className="mt-8 text-sm leading-relaxed text-black/60 sm:text-base">
          foi esse o valor dessa turma: o que tu gastaria num café, por 21 dias
          com a galera certa. entra na lista de espera pra garantir o teu quando
          a próxima abrir.
        </p>

        <div className="mt-8">
          <CtaButton label="entrar na lista de espera" main full className="py-5 text-lg" />
        </div>
      </div>
    </Reveal>
  </section>
);

export default Pricing;
